import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=3b2a4bfc&scoped=true"
import script from "./addressBook.js?vue&type=script&lang=js&external"
export * from "./addressBook.js?vue&type=script&lang=js&external"
import style0 from "./addressBook.scss?vue&type=style&index=0&id=3b2a4bfc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a4bfc",
  null
  
)

export default component.exports